import { Component, OnInit, ViewEncapsulation, input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'src/app/services/localStorage/localStorage.service';
import { Error } from 'src/app/models/error.model';
import { entAnimations } from 'src/app/animations';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { TranslatePipe } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MaterialModule } from 'src/app/material/material.module';
import { UsersTableComponent } from '../users-table/users-table.component';
import { GraphService } from 'src/app/services/graph/graph.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-entity-info',
  templateUrl: './entity-info.component.html',
  styleUrls: ['./entity-info.component.scss'],
  imports: [
    TranslatePipe,
    MatTableModule,
    MatSortModule,
    MaterialModule,
    UsersTableComponent,
  ],
  encapsulation: ViewEncapsulation.None,
  animations: entAnimations,
})
export class EntityInfoComponent implements OnInit {
  readonly entityType = input<'team' | 'group'>(undefined);
  readonly imageUrl = input<string>(undefined);

  isBusy = false;
  isLoading = false;
  entityId: string;
  entityData: any = {};
  returnUrl: string
  spinner = {
    color: 'primary',
    mode: 'indeterminate' as ProgressSpinnerMode,
    value: 50,
    diameter: 50,
  };

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _localStorageService: LocalStorageService,
    private _graphService: GraphService
  ) {
    this.returnUrl = this.getReturnUrl();
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe(params => {
      this.entityData.members = [];
      this.entityId = params['id'];
      if (!this.entityId) {
        this._router.navigate(['/support']);
      }
      this.getEntityData();
    });
  }

  async getEntityData() {
    try {
      this.isBusy = true;
      this.entityData = await lastValueFrom(
        this._graphService.getEntityInfo(this.entityId, this.entityType())
      );
      this._localStorageService.setItem(
        `${this.entityType()}Data`,
        this.entityData
      );
    } catch (e) {
      const customError: Error = e.error
        ? JSON.parse(e.error)
        : { error: undefined };
      if (customError.error?.code === 'ERR404') {
        this._router.navigate(['/errors/error-404']);
      }
    } finally {
      this.isBusy = false;
    }
  }

  getReturnUrl(): string {
    let returnUrl: string = this._localStorageService.getItem('returnUrl');
    if (!returnUrl) {
      returnUrl = `/${this.entityType()}s`;
    }
    this._localStorageService.removeItem('returnUrl');
    return returnUrl;
  }

  return() {
    this._router.navigate([this.returnUrl]);
  }


  get translationEntityOwners() {
    return `SINGLE-${this.entityType().toUpperCase()}.OWNERS`;
  }

  get translationEntityMembers() {
    return `SINGLE-${this.entityType().toUpperCase()}.MEMBERS`;
  }
}
